module.exports = __webpack_public_path__ + "static/media/Spices-stall-India_desktop.5ca38ac8.jpg";